import { BaseBlock } from "../BaseBlock";

import type { Screen } from "../../app/api/ApiClient";

type ConfirmChangeScreen =
    Extract<Screen, { type: "confirmChange" }>;

export class CurrentSubscriptionBlock
    extends BaseBlock {

    private readonly subscription:
        ConfirmChangeScreen["current_subscription"];

    constructor(
        screen: ConfirmChangeScreen
    ) {

        super();

        this.subscription =
            screen.current_subscription;

    }

    public override mount(): void {

        super.mount();

        const root =
            document.createElement("section");

        root.className =
            "subscription-card current-subscription-card";

        // =====================================================
        // Заголовок
        // =====================================================

        const caption =
            document.createElement("div");

        caption.className =
            "subscription-card-caption";

        caption.textContent =
            "Поточна підписка";

        root.appendChild(caption);

        // =====================================================
        // Название
        // =====================================================

        const title =
            document.createElement("h2");

        title.className =
            "subscription-card-title";

        title.textContent =
            this.subscription.title;

        root.appendChild(title);

        // =====================================================
        // Описание
        // =====================================================

        const description =
            document.createElement("div");

        description.className =
            "subscription-card-description";

        description.innerHTML =
            this.subscription.description;

        root.appendChild(description);

        // =====================================================
        // Осталось дней
        // =====================================================

        if (
            this.subscription.remaining_days !== null
        ) {

            const separator =
                document.createElement("hr");

            separator.className =
                "subscription-card-separator";

            root.appendChild(separator);

            const remainingTitle =
                document.createElement("div");

            remainingTitle.className =
                "subscription-card-label";

            remainingTitle.textContent =
                "Залишилось";

            root.appendChild(
                remainingTitle
            );

            const remaining =
                document.createElement("div");

            remaining.className =
                "subscription-card-value";

            remaining.textContent =

                `${this.subscription.remaining_days} днів`;

            root.appendChild(
                remaining
            );

        }

        // =====================================================
        // Цена
        // =====================================================

        const separator2 =
            document.createElement("hr");

        separator2.className =
            "subscription-card-separator";

        root.appendChild(separator2);

        const priceTitle =
            document.createElement("div");

        priceTitle.className =
            "subscription-card-label";

        priceTitle.textContent =
            "Ціна";

        root.appendChild(priceTitle);

        const price =
            document.createElement("div");

        price.className =
            "subscription-card-price";

        price.textContent =

            `${this.subscription.discounted_price_uah} грн`;

        root.appendChild(price);

                this.root = root;

    }

}